import type { FlowModel } from '@shared/flowModel';

/**
 * Frontend default FlowModel (no prompt templates).
 * options are populated at runtime from ratios/styles/tones API data.
 */
export const DEFAULT_FLOW_MODEL: FlowModel = {
  questions: [
    { id: 'imageAspectRatio', type: 'select', title: '選擇輸出規格', page: 1, required: true },
    { id: 'imageStyle',       type: 'select', title: '視覺設計風格', page: 1, required: true },
    { id: 'imageUpload',      type: 'image',  title: '上傳活動素材照片', page: 2, required: false },
    { id: 'usePersonalPhoto', type: 'boolean', title: '套用個人形象照', page: 2, required: false },
    { id: 'textToneInImage',  type: 'select', title: '語氣', page: 2, required: true },
    { id: 'contentInImage',   type: 'text',   title: '圖片文字內容', page: 2, required: true },
  ],
};
